import React, { forwardRef } from 'react';

function SvgDato(props, svgRef) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 16 16"
            width="1em"
            height="1em"
            ref={svgRef}
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.94898 0H0V16H7.94898C11.9243 16 15.8977 12.4181 15.8977 8.00118C15.8977 3.58427 11.9243 0 7.94898 0ZM7.94898 11.6351C7.23002 11.6347 6.52731 11.4212 5.92971 11.0215C5.3321 10.6218 4.86644 10.0539 4.5916 9.38954C4.31676 8.72519 4.24509 7.99426 4.38565 7.28918C4.52621 6.5841 4.8727 5.93654 5.38128 5.42837C5.88987 4.9202 6.53772 4.57425 7.24291 4.43427C7.94811 4.29429 8.67898 4.36657 9.3431 4.64195C10.0072 4.91734 10.5748 5.38347 10.974 5.9814C11.3732 6.57934 11.5861 7.28222 11.5859 8.00118C11.5859 8.47866 11.4919 8.95146 11.3091 9.39257C11.1263 9.83368 10.8584 10.2344 10.5206 10.5719C10.1828 10.9094 9.78185 11.177 9.3406 11.3594C8.89934 11.5419 8.42645 11.6355 7.94898 11.6351V11.6351Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

const ForwardRef = forwardRef(SvgDato);
export default ForwardRef;
